import NextImage from 'next/image';
import { Mail, Phone } from 'lucide-react';
import { getStrapiFormatUrl } from '@/lib/strapi-media-url';
import type { ContactItem } from '@/types/contact';

interface ContactInfoItemProps {
  item: ContactItem;
}

export default function ContactInfoItem({ item }: ContactInfoItemProps) {
  const iconUrl = getStrapiFormatUrl(item.media);
  const href = item.urlOptional?.trim();
  const label = item.heading?.trim() || '';
  const descriptionHtml = item.description?.trim();

  let icon: React.ReactNode;
  if (iconUrl) {
    icon = <NextImage src={iconUrl} alt="" width={14} height={14} className="h-3.5 w-3.5" />;
  } else if (href?.startsWith('mailto:')) {
    icon = <Mail size={14} strokeWidth={2} />;
  } else if (href?.startsWith('tel:')) {
    icon = <Phone size={14} strokeWidth={2} />;
  } else {
    icon = <span className="h-3.5 w-3.5" aria-hidden />;
  }

  const content = descriptionHtml ? (
    <div
      className="break-words text-[13px] leading-relaxed text-black/70 [&_span]:text-black/40"
      dangerouslySetInnerHTML={{ __html: descriptionHtml }}
    />
  ) : (
    <p className="break-words text-[13px] leading-relaxed text-black/70">{label}</p>
  );

  return (
    <div className="flex items-start gap-3.5">
      <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#E31E24]/8 text-[#E31E24]">
        {icon}
      </span>
      <div className="min-w-0 pt-0.5">
        {label ? (
          <p className="mb-0.5 text-[9.5px] font-bold uppercase tracking-[0.18em] text-black/30">
            {label}
          </p>
        ) : null}
        {href ? (
          <a
            href={href}
            target={href.startsWith('http') ? '_blank' : undefined}
            rel={href.startsWith('http') ? 'noopener noreferrer' : undefined}
            className="block transition-colors hover:text-[#E31E24]"
          >
            {content}
          </a>
        ) : (
          content
        )}
      </div>
    </div>
  );
}
